module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"search":"Search","show details":"show details","rack":"Rack","switch":"Switch","description":"Description","alias":"Alias"},"de":{"search":"Suche","show details":"zeige Details","rack":"Rack","switch":"Switch","description":"Beschreibung","alias":"Alias"}}')
  delete Component.options._Ctor
}
